//@flow
import React from 'react';

type IconName = 'x'|'check'|'up-arrow'|'down-arrow'|'comment';

type Props = {
  icon:IconName,
  size:string,
  style?:$Shape<CSSStyleDeclaration>,
  className?:string,
  fill?:string,
};

const VIEW_BOXES:{[IconName]:string} = {
  'x': '0 0 19 19',
  'check': '-293 135 24 24',
  'up-arrow': '0 0 14 8',
  'down-arrow': '0 0 14 8',
  'comment': '0 0 512 512',
};

function _iconSVG(props:Props) {
  const {icon, fill} = props;
  switch (icon) {
    case 'x':
      return (
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill="currentColor">
            <g>
              <g transform="translate(9.435029, 9.435029) rotate(-315.000000) translate(-9.435029, -9.435029) translate(-2.064971, -2.064971)">
                <polygon points="2.41036751 13.5743149 20.871906 13.5743149 22.871906 13.5743149 22.871906 9.57431493 20.871906 9.57431493 2.41036751 9.57431493 0.410367507 9.57431493 0.410367507 13.5743149"></polygon>
                <polygon points="9.64113674 2.3435457 9.64113674 20.8050842 9.64113674 22.8050842 13.6411367 22.8050842 13.6411367 20.8050842 13.6411367 2.3435457 13.6411367 0.343545697 9.64113674 0.343545697"></polygon>
              </g>
            </g>
          </g>
        </g>
      );
    case 'check':
      return (
        <path d="M-292.6,144.3l7.7,7c0.3,0.2,0.6,0.4,1.1,0.4s0.8-0.1,1.1-0.4l13.3-12c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.4-1l-2.1-1.9c-0.3-0.3-0.6-0.4-1.1-0.4s-0.8,0.1-1.1,0.4l-10.2,9.1l-4.6-4.1c-0.3-0.3-0.6-0.4-1.1-0.4s-0.8,0.1-1.1,0.4l-2.1,1.9c-0.3,0.2-0.4,0.6-0.4,1C-293,143.7-292.9,144-292.6,144.3"></path>
      );
    case 'up-arrow':
      return (
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill="#C0BCBC">
            <g transform="translate(7.000000, 4.000000) rotate(180.000000) translate(-7.000000, -4.000000) ">
              <path d="M0.150055991,1.484 L6.68533035,8.0192 C6.76035834,8.12 6.8868981,8.1704 6.98656215,8.1704 C7.1131019,8.1704 7.23852184,8.12 7.31354983,8.0192 L13.8488242,1.484 C13.9496081,1.3832 14,1.2824 14,1.15696 C14,1.05616 13.9496081,0.93072 13.8488242,0.82992 L13.1455767,0.1512 C13.0694289,0.0504 12.944009,0 12.8432251,0 C12.7178052,0 12.5923852,0.0504 12.5173572,0.1512 L6.98656215,5.65712 L1.48264278,0.1512 C1.3818589,0.0504 1.28107503,0 1.1556551,0 C1.03023516,0 0.929451288,0.0504 0.828667413,0.1512 L0.150055991,0.82992 C0.0492721165,0.93072 1.13686838e-13,1.05616 1.13686838e-13,1.15696 C1.13686838e-13,1.2824 0.0492721165,1.3832 0.150055991,1.484" id="Fill-35-Copy-3"></path>
            </g>
          </g>
        </g>
      );
    case 'down-arrow':
      return (
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill={fill || "#C0BCBC"}>
            <g>
              <path d="M0.150055991,1.484 L6.68533035,8.0192 C6.76035834,8.12 6.8868981,8.1704 6.98656215,8.1704 C7.1131019,8.1704 7.23852184,8.12 7.31354983,8.0192 L13.8488242,1.484 C13.9496081,1.3832 14,1.2824 14,1.15696 C14,1.05616 13.9496081,0.93072 13.8488242,0.82992 L13.1455767,0.1512 C13.0694289,0.0504 12.944009,0 12.8432251,0 C12.7178052,0 12.5923852,0.0504 12.5173572,0.1512 L6.98656215,5.65712 L1.48264278,0.1512 C1.3818589,0.0504 1.28107503,0 1.1556551,0 C1.03023516,0 0.929451288,0.0504 0.828667413,0.1512 L0.150055991,0.82992 C0.0492721165,0.93072 1.13686838e-13,1.05616 1.13686838e-13,1.15696 C1.13686838e-13,1.2824 0.0492721165,1.3832 0.150055991,1.484"></path>
            </g>
          </g>
        </g>
      );
    case 'comment':
      return (
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill={fill || "#C0BCBC"}>
            <g>
              <path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"></path>
            </g>
          </g>
        </g>
      );
    // Add more icons here
  }
}

// Adapted from http://dmfrancisco.github.io/react-icons/
export default function Icon(props:Props) {
  const styles = {
    fill: props.fill || 'currentcolor',
    verticalAlign: 'middle',
    width: props.size, // CSS instead of the width attr to support non-pixel units
    height: props.size, // Prevents scaling issue in IE
  };

  return (
    <div
      style={{ display: 'inline' }}
      className={props.className}
    >
      <svg
        viewBox={VIEW_BOXES[props.icon]}
        preserveAspectRatio="xMidYMid meet"
        style={Object.assign({}, styles, props.style || {})}
      >
        {_iconSVG(props)}
      </svg>
    </div>
  );
}
